'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { useState } from 'react';

import { ColorTelegramIcon } from '@/shared';

import type { IReviewItem, IReviews } from '../../types';
import css from './styles.module.css';

const iconMap = {
	telegram: ColorTelegramIcon,
};

const ReviewItem = ({
	review,
	showMoreText = 'Показать больше',
	showLessText = 'Скрыть',
}: {
	review: IReviewItem;
	showMoreText?: string;
	showLessText?: string;
}) => {
	const [open, setOpen] = useState(false);
	const toggleOpen = () => setOpen(!open);
	const textClassName = clsx(css.itemText, {
		[css.itemTextActive]: open,
	});

	return (
		<dl className={css.item}>
			<dt className="flex flex-row justify-between gap-2">
				<div className="flex flex-col gap-2 text-base text-[#252F4A] xl:text-2xl">
					<b>{review.name}</b>
					{review.position && (
						<span className="text-xs text-[#4B5675] xl:text-base">
							{review.position}
						</span>
					)}
				</div>
				<div className={css.itemLinks}>
					{(review?.links ?? []).map((link, key) => {
						const IconComponent = iconMap[link.icon as keyof typeof iconMap];
						return IconComponent ? (
							<Link
								key={key}
								href={link.href}
								target="_blank"
								rel="noopener noreferrer"
							>
								<IconComponent className="size-6" />
							</Link>
						) : null;
					})}
				</div>
			</dt>
			<dd className={textClassName}>{review.content}</dd>
			<button type="button" className={css.itemShowMore} onClick={toggleOpen}>
				{open ? showLessText : showMoreText}
			</button>
		</dl>
	);
};

export const Reviews = ({
	reviews,
	showMoreText = 'Показать еще',
	itemsPerPage = 3,
}: IReviews) => {
	const [limit, setLimit] = useState(itemsPerPage);
	const onShowMore = () =>
		setLimit(Math.min(limit + itemsPerPage, reviews.length));

	return (
		<>
			<div className={css.reviews}>
				{reviews.slice(0, limit).map((review, key) => (
					<div key={key}>
						<ReviewItem review={review} />
					</div>
				))}
			</div>
			{limit < reviews.length && (
				<div className="text-center">
					<button type="button" className={css.showMore} onClick={onShowMore}>
						{showMoreText}
					</button>
				</div>
			)}
		</>
	);
};
